import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';

const problemDescription = (props) => {

  return (
    <Row className="justify-content-md-center">
      <Col xs={12}>
        <Form>
          <Form.Group>
            <Form.Label><i className="fa fa-comment-o"></i> Sisestage täiendav info</Form.Label>
            <Form.Control as="textarea" rows={3} value={props.value} onChange={(e) => props.changed(e)} name="trumpauto-problem-description" />
          </Form.Group>

        </Form>
      </Col>
    </Row>
  );
};

export default problemDescription;